module.exports = __webpack_public_path__ + "img/quality-assurance.16819964.jpg";